export var ErrorTypes = /*#__PURE__*/ function(ErrorTypes) {
    ErrorTypes[ErrorTypes["DefaultError"] = 0] = "DefaultError";
    ErrorTypes[ErrorTypes["AuthError"] = 1] = "AuthError";
    ErrorTypes[ErrorTypes["MustLogin"] = 2] = "MustLogin";
    ErrorTypes[ErrorTypes["MustBeMember"] = 3] = "MustBeMember";
    ErrorTypes[ErrorTypes["Blocking"] = 4] = "Blocking";
    return ErrorTypes;
}({});
export var HTTPStatus = /*#__PURE__*/ function(HTTPStatus) {
    HTTPStatus[HTTPStatus["Ok"] = 200] = "Ok";
    HTTPStatus[HTTPStatus["BadRequest"] = 400] = "BadRequest";
    HTTPStatus[HTTPStatus["Unauthorized"] = 401] = "Unauthorized";
    HTTPStatus[HTTPStatus["Forbidden"] = 403] = "Forbidden";
    HTTPStatus[HTTPStatus["NotFound"] = 404] = "NotFound";
    HTTPStatus[HTTPStatus["Conflict"] = 409] = "Conflict";
    HTTPStatus[HTTPStatus["TooManyRequests"] = 429] = "TooManyRequests";
    HTTPStatus[HTTPStatus["InternalServerError"] = 500] = "InternalServerError";
    HTTPStatus[HTTPStatus["ServiceUnavailable"] = 503] = "ServiceUnavailable";
    return HTTPStatus;
}({});
